import XLSX from 'xlsx';

import React from 'react';
import PropTypes from 'prop-types';
import FileSaver from 'file-saver';
import { connect } from 'react-redux';

import { getFilteredDataset } from 'store/dataset';

import ContentComponent from './Component';

const s2ab = s => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);

  for (let i = 0; i !== s.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    view[i] = s.charCodeAt(i) & 0xFF;
  }

  return buf;
};

class ContentContainer extends React.PureComponent {
  static propTypes = {
    filteredDataset: PropTypes.arrayOf(
      PropTypes.object.isRequired
    ).isRequired
  }

  constructor (props) {
    super(props);

    this.state = {
      selectedType: 'CSV',
      errorOccured: false
    };

    this.handleTypeChange = ({ target }) =>
      this.setState({ selectedType: target.value });

    this.handleDownloadButtonClick = () => {
      this.setState({ errorOccured: false });

      try {

        const ext = this.state.selectedType.toLowerCase();
        const ws = XLSX.utils.json_to_sheet(this.props.filteredDataset);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Filtered dataset');
        const wbout = XLSX.write(wb, { type: 'binary', bookType: ext });

        FileSaver.saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `filtered-dataset.${ext}`);

      } catch (e) {
        this.setState({ errorOccured: true });
      }
    };
  }

  render () {
    return (
      <ContentComponent
        {...this.state}
        onTypeChange={this.handleTypeChange}
        onDownloadButtonClick={this.handleDownloadButtonClick}
      />
    );
  }
}

const mapStateToProps = state => ({
  filteredDataset: getFilteredDataset()(state)
});

export default connect(mapStateToProps)(ContentContainer);
